import React from 'react';
import BraintreeDropIn from 'braintree-web-drop-in-react';
import ReCAPTCHA from 'react-google-recaptcha';

import Loading from 'components/Loading';
import PaymentNonceDebugOverride from 'components/PaymentNonceDebugOverride';
import { IPaymentPlan } from 'types/payment';


type Props = {
  isSubmitting: boolean,
  isWaitingForInstance: boolean,
  message?: string,
  onInstance?: (_?: any) => void,
  onReCaptchaChange: (_?: any) => void,
  onSelect: (_?: any) => void,
  onSetNonce: any,
  onSubmit: (_?: any) => void,
  options: any,
  plans: IPaymentPlan[],
  selectedPlanId: string,
};

interface State {
  isReCaptchaValid: boolean,
}

export default class PurchaseSubscriptionComponent extends React.Component<Props, State> {
  state = {
    isReCaptchaValid: false,
  };

  handleReCaptchaChange = (value: any) => {
    const { onReCaptchaChange } = this.props;
    this.setState({ isReCaptchaValid: true });
    onReCaptchaChange(value);
  };

  render() {
    const {
      isSubmitting,
      isWaitingForInstance,
      message,
      onInstance,
      onSelect,
      onSetNonce,
      onSubmit,
      options,
      plans,
      selectedPlanId,
    } = this.props;

    const { isReCaptchaValid } = this.state;

    return (
      <div className="subscription-panel">
        <form method="post" onSubmit={onSubmit}>
          <label htmlFor="planId">Choose currency: </label>
          <select
            name="planId"
            id="planId"
            style={{ border: '2px solid #666666', borderRadius: 2, marginLeft: 8 }}
            onChange={onSelect}
            value={selectedPlanId}
          >
            {plans.map(plan => (
              <option key={plan.id} value={plan.id}>
                {plan.price}
                {' '}
                {plan.currencyIsoCode}
              </option>
            ))}
          </select>
          <p style={{ padding: '8px 0' }}>
            Creating a subscription will automatically renew your Exceptional Friendship every month
            {' '}
            and charge the amount chosen above to your chosen payment method.
          </p>
          <PaymentNonceDebugOverride
            onSelect={onSetNonce}
          />
          {message && <p className="subscription-panel__message">{message}</p>}
          <BraintreeDropIn
            options={options}
            onInstance={onInstance}
          />
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <ReCAPTCHA
              sitekey="6Ldu784UAAAAAI2pquK8B8q4lgT6vXY-Dpa8mu4S"
              onChange={this.handleReCaptchaChange}
            />
          </div>
          <div id="button-container" style={{ margin: '24px 0' }}>
            <button
              className="button button--secondary"
              disabled={isWaitingForInstance || !isReCaptchaValid || isSubmitting}
              style={{ marginTop: 10, float: 'right', clear: 'both' }}
              type="submit"
            >
              {(isSubmitting || isWaitingForInstance) ? <Loading spinner small /> : 'Buy Subscription'}
            </button>
          </div>
        </form>
      </div>
    );
  }
}
